import { DataType } from '@lmt/shared-types';
import { UIEditorBlockWidth } from '@lmt/unicorn-shared/app/components/editor/components/blocks/WidthSelectControl';

export enum DictionaryType {
  DropDown = 1,
  RadioGroup = 2,
  RadioGroupWithCustomOption = 3,
  CheckboxGroup = 4,
  CheckboxGroupWithCustomOption = 5,
  Combobox = 6,
}

export const dictionaryTypes = [
  DictionaryType.DropDown,
  DictionaryType.RadioGroup,
  DictionaryType.RadioGroupWithCustomOption,
  DictionaryType.CheckboxGroup,
  DictionaryType.CheckboxGroupWithCustomOption,
  DictionaryType.Combobox,
];

export type DefaultProps = {
  size: UIEditorBlockWidth;
  isLabel: boolean;
  label: string;
  isEditable: boolean;
  isMultiline: boolean;
  format: string;
  isMandatory: boolean;
  isShared: boolean;
  dictionaryType?: DictionaryType;
  // for hardcoded fields we could pass dictionaryTitle via this prop
  dictionaryTitle?: string | undefined | null;
  isDictionaryItemAdding?: boolean;
  isSingleValue: boolean;
  isOptionAllowed: boolean;
  expression: string;
  visibleOptionsNumber?: number;
  isHiddenWhenEmpty?: boolean;
  // for hardcoded fields
  isRequired?: boolean;
};

export type MandatoryProps = {
  dataKey: string;
  dataType: DataType;
  dataBlockFieldId: number;
};

export type InputProps = DefaultProps & MandatoryProps;
